<!-- Bloomberg Terminal Pro Footer -->
<footer id="footer" tabindex="-1" class="h-8 border-t border-bb-border bg-bb-bg-secondary px-3 flex items-center justify-between">
  <!-- Left: Version & Status -->
  <div class="flex items-center gap-3">
    <span class="font-mono text-2xs text-bb-text-muted">(C) {{ currentYear }} RAZOR</span>
    <div class="w-px h-3 bg-bb-border"></div>
    <span class="font-mono text-2xs text-bb-text-muted uppercase tracking-wider">v{{ appVersion }}</span>
    <div class="w-px h-3 bg-bb-border hidden sm:block"></div>
    <div class="hidden sm:flex items-center gap-1.5" data-testid="footer-api-status">
      <span class="w-1.5 h-1.5 rounded-full" [class]="apiStatusDotClass()" data-testid="footer-status-dot"></span>
      <span class="font-mono text-2xs uppercase tracking-wider" [class]="apiStatusClass()">
        {{ apiStatusDisplay() }}
      </span>
      @if (apiStatusCaveat(); as caveat) {
        <!-- F-FU-37: visible, focusable caveat; the full list is its tooltip on
             hover, keyboard focus or tap, and its accessible description. -->
        <span
          tabindex="0"
          class="font-mono text-2xs text-bb-text-muted underline decoration-dotted underline-offset-2 cursor-help"
          data-testid="footer-api-status-caveat"
          [uiTooltip]="caveat"
          tooltipTrigger="hover-focus"
          tooltipPosition="top"
        >· {{ apiStatusCaveatShort() }}</span>
      }
    </div>
  </div>

  <!-- Right: Links -->
  <div class="flex items-center gap-3">
    <a href="/help" class="font-mono text-2xs text-bb-text-muted hover:text-bb-text-secondary transition-colors uppercase tracking-wider">
      Docs
    </a>
    <div class="w-px h-3 bg-bb-border"></div>
    <a href="/help" class="font-mono text-2xs text-bb-text-muted hover:text-bb-text-secondary transition-colors uppercase tracking-wider">
      Support
    </a>
    <div class="w-px h-3 bg-bb-border hidden sm:block"></div>
    <a href="/system-health/overview" class="hidden sm:inline font-mono text-2xs text-bb-text-muted hover:text-bb-text-secondary transition-colors uppercase tracking-wider">
      Status
    </a>
  </div>
</footer>
